import { Container } from "react-bootstrap";
import BreadCrumb from "../components/Breadcrumb";

function FeatureLayout({ title, extracss, children }) {
  return (
    <div className={`u-pt-huge u-pb-huge ${extracss ? extracss : ""}`}>
      <BreadCrumb title={title} />
      <Container>{children}</Container>
    </div>
  );
}

export default FeatureLayout;
